import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-instagram",
  "use": "foquz-icon-instagram-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" id=\"foquz-icon-instagram\"><path d=\"M14.95 5.472h.009M5.5 1.422h9a4.5 4.5 0 014.5 4.5v9a4.5 4.5 0 01-4.5 4.5h-9a4.5 4.5 0 01-4.5-4.5v-9a4.5 4.5 0 014.5-4.5zm8.1 8.433a3.6 3.6 0 11-7.122 1.056A3.6 3.6 0 0113.6 9.855z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol